import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setActiveCRGObject,
  setActiveCRGObjectFloor,
} from 'emergency_data/src/actions/spatialLayers';
import useDebounce from '@rsos/utils/useDebounce';
import { Modal } from '../../../../base';
import ExpandedMapDialog from '../../MapDialog/ExpandedMapDialog';
import { CRGSpatialLayerSelector } from '../../SpatialLayers/selectors';
import { showPopover, hidePopover } from '../MapPopover/mapPopoverSlice';
import StaticLayerGL from './StaticLayerGL';

/**
 * CRG map handling using Deck.GL
 * @param {Object} overlay -
 * @param {removedID} removedID - Phone number of a call that was removed from the queue
 */
const CRGGL = ({ overlay, removedID }) => {
  const [activeMarkerId, setActiveMarkerId] = useState(null);

  const dispatch = useDispatch();

  const CRGLayers = useSelector(state => {
    return CRGSpatialLayerSelector(state.spatialLayers.staticLayers) || [];
  });

  const activeCrgObject = useSelector(
    state => state.spatialLayers.activeCrgObject,
  );

  const handleMarkerClick = spatialObject => {
    dispatch(setActiveCRGObject(spatialObject));
    setActiveMarkerId(spatialObject.id);
  };

  const handleCloseCrgCard = () => {
    dispatch(setActiveCRGObject(null));
    dispatch(setActiveCRGObjectFloor(null));
    dispatch(hidePopover());
  };

  const isModalOpen = Object.keys(activeCrgObject.spatialObject).length > 0;
  useEffect(() => {
    if (!isModalOpen) {
      setActiveMarkerId(null);
    }
  }, [isModalOpen]);

  const handleMarkerHover = useDebounce(
    o => {
      if (o) {
        const pop = {
          spatialLayerKey: o.spatialObject?.external_id,
          spatialLayer: o.spatialLayer,
          spatialObject: o.spatialObject,
        };
        dispatch(showPopover(pop));
      } else {
        dispatch(hidePopover());
      }
    },
    100,
    [],
  );
  return (
    <>
      {CRGLayers.map((spatialLayer, i) => {
        return (
          <StaticLayerGL
            key={`${spatialLayer.id}-${i}`}
            overlay={overlay}
            spatialLayer={spatialLayer}
            onClick={handleMarkerClick}
            activeMarkerId={activeMarkerId}
            filled={false}
            onHover={handleMarkerHover}
          />
        );
      })}
      {isModalOpen && (
        <Modal
          id="expanded-map-dialog"
          onClose={handleCloseCrgCard}
          isOpened
          transparent
          disableBackdropClick
        >
          <ExpandedMapDialog
            onClose={handleCloseCrgCard}
            removedID={removedID}
          />
        </Modal>
      )}
    </>
  );
};

export default CRGGL;
